import $ from 'jquery';
import 'slick-carousel';
let slideIndex = 1;
class GolfCarousel {
  constructor(element){
    this.$el = $(element);
    this.els = {
      slides : this.$el.find('.slides'),
      counter : this.$el.find('.slide-count'),
    };
    this.slickOptions = {
      arrows:false,
      infinite:true,
      dots: true,
      customPaging : function(slider, i) {
        if (i == 0) {
          return '<a>All</a>';
        }else{
          let str = '<a>'+(slideIndex)+'</a>';
          slideIndex += 1;
          return str;
        }
      },
      slidesToShow:1,
      waitForAnimate:false,
      autoplay: false
    };

    this.buildCarousel();
  }

  destroyCarousel() {
    if (this.els.slides.hasClass('slick-initialized')) {
      this.els.slides.slick('unslick');
    }
  }

  buildCarousel() {
    let that = this;
    that.els.slides.slick(that.slickOptions);
  }
}

if($('.golf-carousel-component').length) {
  $('.golf-carousel-component').each(function(index,element) {
    new GolfCarousel(element, index);
  });
}
